import axios from "axios";
import { API } from "@/lib/api";

/** Dedicated axios instance for unauthenticated Cloudivo Meet attendees — guests
 * never get an httponly session cookie (they don't have a platform account), so
 * their meeting-scoped guest access token travels as a Bearer header instead,
 * read fresh from sessionStorage on every request. */
const guestApi = axios.create({ baseURL: API });

guestApi.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("cloudivo_guest_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function saveGuestSession(meetingId, guestToken, name) {
  sessionStorage.setItem("cloudivo_guest_token", guestToken);
  sessionStorage.setItem("cloudivo_guest_meeting_id", meetingId);
  sessionStorage.setItem("cloudivo_guest_name", name || "Guest");
}

export function getGuestSession(meetingId) {
  const token = sessionStorage.getItem("cloudivo_guest_token");
  const storedMeetingId = sessionStorage.getItem("cloudivo_guest_meeting_id");
  if (!token || storedMeetingId !== meetingId) return null;
  return { token, name: sessionStorage.getItem("cloudivo_guest_name") || "Guest" };
}

export function clearGuestSession() {
  sessionStorage.removeItem("cloudivo_guest_token");
  sessionStorage.removeItem("cloudivo_guest_meeting_id");
  sessionStorage.removeItem("cloudivo_guest_name");
}

export default guestApi;
